import { isObjectId } from '../object-id.js';
/**
 * Sérialisation canonique : clés triées, `undefined` omis, `ObjectId` en hex, `Date` en ISO.
 *
 * Elle sert à une seule chose — des comparaisons et des empreintes reproductibles (15 §11 : « the
 * effective model MUST be deterministic »). Deux entrées égales donnent la même chaîne quel que
 * soit l'ordre dans lequel leurs clés ont été écrites. Ce module ne dépend d'aucune API Node :
 * l'évaluateur d'expressions, qui en a besoin, tourne aussi dans le navigateur (ADR-048).
 */
export function canonicalJson(value) {
    return JSON.stringify(canonicalize(value));
}
function canonicalize(value) {
    if (value === null || value === undefined)
        return value ?? null;
    if (isObjectId(value))
        return value.toHexString();
    if (value instanceof Date)
        return value.toISOString();
    if (Array.isArray(value))
        return value.map((entry) => (entry === undefined ? null : canonicalize(entry)));
    if (typeof value === 'object') {
        const out = {};
        for (const key of Object.keys(value).sort()) {
            const entry = value[key];
            if (entry !== undefined)
                out[key] = canonicalize(entry);
        }
        return out;
    }
    return value;
}
/** Égalité structurelle, au sens de la forme canonique. */
export function canonicallyEqual(a, b) {
    return canonicalJson(a) === canonicalJson(b);
}
//# sourceMappingURL=canonical-json.js.map